<template>
	<div class="workdialog">
		<div class="otitle">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
		</div>
		<div class="table">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="100px">
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column label="渠道" align="center" header-align="center">
					<template slot-scope="scope">
						{{mydata.shop.shop_name}}
					</template>
				</el-table-column>
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_price" label="单价" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="true_num" label="实发数量" align="center" header-align="center">
				</el-table-column>
			</el-table>

			<div class="item">
				<div class="ohead">
					订单工单申请
				</div>
				<work :isSingle="0" :mydata="mydata" ref="work" v-if="workload" @onsub="subwork"></work>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Workdialog',
		data() {
			return {
				mydata: {
					buy_user: {},
					order: {},
					order_detail: [],
					oredr_delivery: [],
					shop: {},
				},
				
				workload: false
			}
		},

		mounted() {
			this.oninfo();
		},
		
		props: {
			checkobj: {
				type: Object,
				default: {}
			}
		},

		methods: {
			oninfo() {
				var obj = {
					trade_no: this.checkobj.trade_no
				}

				this.$axios.post('api/user/order_info', obj).then(res => {
					if (res.data.code == 0) {
						this.mydata = res.data.data;
						this.workload = true;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsub(){
				this.$refs.work.onsubform();
			},
			
			subwork(res) {
				this.$emit('subwork',res);
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 50%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:nth-child(3) {
			border-right: none;
		}
	}
	
	.item {
		width: 100%;
		margin-bottom: 10px;
		margin-top: 10px;
		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;
			margin-bottom: 20px;
			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/workdialog.vue